import React, { useEffect, useState } from 'react'
import Login from './Login'

// css start 
import "../CSS/login.css"
import "../CSS/home.css"
import "../CSS/global.css"
// css end


// react icons start 
import { IoIosArrowBack, IoIosArrowForward, IoMdAdd } from "react-icons/io";
import { IoLockClosedSharp, IoReload } from "react-icons/io5";
import { IoIosLogOut } from "react-icons/io";
// react icons end


// images start 
import software_details1 from "../assets/sidebar/software_details1.png"
import setting_apple_icon from "../assets/sidebar/setting_apple_icon.webp"
import usage_and_ownership from "../assets/sidebar/usage_and_ownership.png"
import licence_and_renewal from "../assets/sidebar/licence_and_renewal.png"
import hosting from "../assets/sidebar/hosting.png"
import service_provider from "../assets/sidebar/service_provider.png"
import user from "../assets/sidebar/user.png"
import cloud_server from "../assets/sidebar/cloud-server.png"
import SoftwareDetails from './SoftwareDetails'
import Ownership from './Ownership'
import Licence from './Licence'
import Hosting from './Hosting'
import Vendor from './Vendor'
import User from './User'
import AllSoftware from './AllSoftware'
import axios from 'axios'
import { API } from './constant'
import Masters from './Masters'
import AccountDetails from './AccountDetails'
import Invoices from './Invoices'
// images end






const Home = ({ children }) => {
    const [activeModal, setactiveModal] = useState("all-software")
    const [userRole, setUserRole] = useState("")

    const fetchUserRole = async () => {
        try {
            const response = await axios.get(`${API}/register/get-user-role`)
            // console.log(response.data.data)
            setUserRole(response.data.data)
        } catch (error) {
            console.log("Error fetching user role", error)
        }
    }

    useEffect(()=>{
        fetchUserRole()
    },[])

const menuItems = [
    // { key: "software", label: "Software", icon: software_details1 },
    // { key: "ownership", label: "Ownership", icon: usage_and_ownership },
    // { key: "licence", label: "Licence", icon: licence_and_renewal },
    // { key: "hosting", label: "Hosting", icon: hosting },
    // { key: "vendor", label: "Vendor", icon: service_provider },
    { key: "all-software", label: "software", icon: software_details1 },
    ...(userRole && userRole === "SUPER ADMIN"  ? [{ key: "master", label: "Master", icon: setting_apple_icon }] : []),
    ...(userRole && userRole === "SUPER ADMIN"  ? [{ key: "user", label: "User", icon: user }] : []),
    ...(userRole && userRole === "SUPER ADMIN"  ? [{ key: "account-details", label: "Accounts", icon: cloud_server }] : []),
    ...(userRole && userRole === "SUPER ADMIN"  ? [{ key: "invoices", label: "Invoices", icon: service_provider }] : []),
]


    const logout = () => {
        localStorage.removeItem("token")
        window.location.href = "/"
    }



    return (
        <div className=''>
            <div className='login_bg DFJCCBICFDC gap50'>
                <div></div>

                <div className='apple_design_container_outer '>
                    <div className='apple_design_container_inner'>
                        <div>
                            <div className='apple_design_container_header DFJCBAIC'>
                                <div className='DFJCCAIC gap50'>
                                    <div className='apple_minimise_ryg'>
                                        <span className=''> </span>
                                        <span></span>
                                        <span></span>
                                    </div>

                                    <div className='apple_arrow_front_back DFJCCAIC gap10'>
                                        <span><IoIosArrowBack size={20} color='#d8d8d8' /></span>
                                        <span><IoIosArrowForward size={20} color='#d8d8d8' /></span>
                                    </div>

                                </div>

                                <div className='apple_search_header_container  '>
                                    <div className='DFJCBAIC'>
                                        <div></div>
                                        <div className='DFJCCAIC gap5'>
                                            <span><IoLockClosedSharp color='#7e7e7e' /></span>
                                            <span>softTrack.com/
                                                {/* {activeModal === "software" && "software"}
                                                {activeModal === "ownership" && "ownership"}
                                                {activeModal === "licence" && "licence"}
                                                {activeModal === "hosting" && "hosting"}
                                                {activeModal === "vendor" && "vendor"} */}
                                                {activeModal === "all-software" && "all-software"}
                                                {activeModal === "master" && "master"}
                                                {activeModal === "user" && "user"}
                                                {activeModal === "account-details" && "account-details"}
                                                {activeModal === "invoices" && "invoices"}
                                            </span>
                                        </div>
                                        <div>
                                            <span><IoReload color='#7e7e7e' /></span>
                                        </div>

                                    </div>
                                </div>

                                <div className='apple_arrow_front_back DFJCCAIC gap10'>

                                    <span className='SmallText flex items-center gap10 cursor-pointer textGrey' onClick={logout}>Logout <IoIosLogOut size={20} /></span>
                                </div>

                            </div>
                        </div>


                        <hr />


                    </div>

                    <div className='chidren_container'>
                        {children}
                        {/* {activeModal === "software" && <SoftwareDetails />}
                        {activeModal === "ownership" && <Ownership />}
                        {activeModal === "licence" && <Licence />}
                        {activeModal === "hosting" && <Hosting />}
                        {activeModal === "vendor" && <Vendor />} */}
                        {activeModal === "all-software" && <AllSoftware />}
                        {activeModal === "master" && <Masters />}
                        {activeModal === "user" && <User />}
                        {activeModal === "account-details" && <AccountDetails />}
                        {activeModal === "invoices" && <Invoices />}
                    </div>
                </div>

                {/* <div className='menubar_container marginT20'>
                    <div className='menubar_container_outer'>
                        <div className='menubar_container_outer DFJCCAIC gap20'>
                            {menuItems.map(item => (
                                <div key={item.key}
                                    className='icon_container padding0515 textCenter'
                                    onClick={() => setactiveModal(item.key)}>
                                    <img className='app_icon h-[45px] w-[45px]' src={item.icon} />
                                    <span className='extraSmallText textDarkGrey'>{item.label}</span>
                                </div>
                            ))}

                        </div>
                    </div>
                </div> */}
                <div className="menubar_container marginT20">
                    <div className="menubar_outer glass-morph">

                        {/* <p className=''>
                        {userRole}
                        </p> */}
                        <div className="menubar_inner DFJCCAIC gap-6 px-5 py-2.5">



                            {menuItems.map((item) => (
                                <button
                                    key={item.key}
                                    type="button"
                                    className="app-item group"
                                    onClick={() => setactiveModal(item.key)}
                                >
                                    <div className="icon-wrapper">
                                        <img
                                            className="app_icon h-11 w-11 object-contain transition-all duration-300 ease-out group-hover:scale-110 group-hover:-translate-y-1"
                                            src={item.icon}
                                            alt={item.label}
                                            draggable={false}
                                        />
                                    </div>
                                    <span className="extraSmallText mt-1.5 block text-gray-200/90 group-hover:text-white transition-colors">
                                        {item.label}
                                    </span>
                                </button>
                            ))}



                        </div>
                    </div>
                </div>

            </div>
        </div>
    )
}

export default Home